// extracted by mini-css-extract-plugin
module.exports = {"companySection":"company-module--companySection--Xh3me","title":"company-module--title--2U4tz"};